import React, { memo, useCallback } from 'react';
import type { FunilIaStageSlug } from '../funilIaStage';
import type { FunilCampaignSwatch } from '../funilCampaignPalette';

export interface PhysicsBallProps {
  leadId: string;
  lane: FunilIaStageSlug;
  initial: string;
  leadName: string;
  campaignId: string;
  /** ausente: gradiente nativo do `lane` (borda de etapa) — *physics* padrão. */
  swatch?: FunilCampaignSwatch;
  registerBall: (leadId: string, el: HTMLElement | null) => void;
  onClick?: () => void;
}

/**
 * Shell estático da bolinha: posição, classes e centro (letra / «typing») são
 * atualizados por `syncPhysicsBallDom` no rAF — evita re-render a 60fps.
 */
export const PhysicsBallComponent = memo(function PhysicsBallComponent({
  leadId,
  lane,
  initial,
  leadName,
  campaignId,
  swatch,
  registerBall,
  onClick,
}: PhysicsBallProps) {
  const setRootRef = useCallback(
    (el: HTMLElement | null) => {
      registerBall(leadId, el);
    },
    [leadId, registerBall],
  );

  return (
    <div
      ref={setRootRef}
      className="funil-ia-ball"
      role="button"
      tabIndex={0}
      onClick={onClick}
      onKeyDown={(e) => {
        if (e.key === 'Enter') onClick?.();
      }}
      aria-label={`Lead: ${leadName}`}
      data-lead-id={leadId}
      data-campaign-id={campaignId}
      data-lane={lane}
      data-initial={initial}
    >
      <span className="funil-ia-ball-tip">{leadName}</span>
      {/* Conteúdo preenchido por syncPhysicsBallDom (rAF) */}
      <span className="funil-ia-ball-face" />
    </div>
  );
}, (a, b) => {
  if (
    a.leadId !== b.leadId ||
    a.lane !== b.lane ||
    a.initial !== b.initial ||
    a.campaignId !== b.campaignId ||
    a.leadName !== b.leadName
  ) {
    return false;
  }
  if (!a.swatch && !b.swatch) return true;
  if (!a.swatch || !b.swatch) return false;
  return (
    a.swatch.circleFrom === b.swatch.circleFrom &&
    a.swatch.circleTo === b.swatch.circleTo &&
    a.swatch.thinkingGlow === b.swatch.thinkingGlow
  );
});
